import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { IconButton } from '@material-ui/core'
import { Phone, MicOff } from '@material-ui/icons'
import { call } from 'actions/inbox'
// import { Device } from 'twilio-client'
import { getClientToken, getClientTokenSchema } from 'actions/voice'
import { toggleModal, setPhoneState } from 'actions/phone'
// import { Link } from 'react-router-dom'
// import contactLabel from 'utils/contactLabel'
import secondsToDhms from 'utils/secondsToDhms'
import { toggleManagePhonesModal } from 'actions/tasks'
import { withStyles } from '@material-ui/core'

const LogBox = ({ text }) => (
  <div>
    <div style={{ fontSize: 16, minHeight: 19 }}>{text}</div>
  </div>
)

// const urlParams = new URLSearchParams(window.location.search)
// const jwtToken = urlParams.get('jwtToken')

const styles = theme => ({
  root: {
    cursor: 'default',
  },
})

class PhoneCall extends Component {
  constructor(props) {
    super(props)
    this.state = { time: 0 }
  }

  componentDidMount() {
    // console.log('<PhoneCallDialog /> componentDidMount')
    if (this.props.startTime && this.props.phoneTo === this.props.to) {
      this.timerID = setInterval(() => this.tick(), 1000)
    }
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.startTime !== prevProps.startTime &&
      this.props.startTime &&
      this.props.phoneTo === this.props.to
    ) {
      console.log(
        'this.props.startTime !== prevProps.startTime && this.props.startTime',
      )
      this.timerID = setInterval(() => this.tick(), 1000)
    }

    if (this.props.startTime !== prevProps.startTime && !this.props.startTime) {
      console.log(
        'this.props.startTime !== prevProps.startTime && !this.props.startTime',
      )
      clearInterval(this.timerID)
      this.setState({ time: 0 })
    }

    if (
      this.props.phoneTo === this.props.to &&
      prevProps.to !== this.props.to
    ) {
      this.timerID = setInterval(() => this.tick(), 1000)
    }

    if (
      this.props.phoneTo !== this.props.to &&
      prevProps.to !== this.props.to
    ) {
      clearInterval(this.timerID)
      this.setState({ time: 0 })
    }
  }

  componentWillUnmount() {
    this.setState({ time: 0 })
    clearInterval(this.timerID)
  }

  tick() {
    if (this.props.startTime) {
      this.setState({
        time: Math.floor((Date.now() - this.props.startTime) / 1000),
      })
    }
  }

  toggleCall = () => {
    // console.log('<PhoneCall /> toggleCall()')
    if (this.props.onPhone) {
      this.props.setPhoneState({ onPhone: false, muted: false })
    } else {
      this.props.setPhoneState({ onPhone: true, muted: false })
    }
  }

  render() {
    const disabled = this.props.phoneTo !== this.props.to && this.props.phoneTo

    return (
      <div
        style={{
          height: 110,
        }}
      >
        <div style={{ position: 'absolute', bottom: 5, right: 5 }}>
          <button
            style={{
              backgroundColor: 'transparent',
              border: 'none',
              cursor: 'pointer',
              textDecoration: 'underline',
              display: this.props.messageMenuOpen ? 'inline' : 'none',
              margin: 0,
              padding: 0,
              fontSize: 16,
              color: 'blue',
            }}
            href="#"
            onClick={() => this.props.toggleManagePhonesModal()}
          >
            Manage phones
          </button>
        </div>
        {/* <div
          style={{
            position: 'absolute',
            left: '50%',
            top: '-2px',
            transform: 'translate(-50%, 0)',
						textAlign: 'center',
          }}
        >
          <span style={{ color: 'gray', fontSize: 15, maxWidth: 320 }}>
            Calls are currently disabled while we are upgrading our services.
          </span>
        </div> */}
        <div
          style={{
            margin: '10px auto 0',
            width: '50%',
            textAlign: 'center',
          }}
        >
          <div style={{ fontSize: 22, minHeight: 25 }}>
            {this.props.onPhone && !disabled
              ? secondsToDhms(this.state.time)
              : null}
          </div>
          <IconButton
            disabled={disabled || !this.props.onPhone}
            onClick={() => {
              this.props.setPhoneState({ muted: !this.props.muted })
            }}
            style={{
              backgroundColor: this.props.muted ? 'gray' : 'transparent',
              color: this.props.muted ? '#fff' : 'gray',
            }}
          >
            <MicOff />
          </IconButton>
        
            <IconButton
               disabled={disabled}
               onClick={() => this.toggleCall()}
              //onClick={() => console.log('currently disabled')}
              style={{
                backgroundColor:
                   disabled
									?   'gray'
                 : this.props.onPhone
									? 'red'
									: '#19B940', color: '#fff',
              }}
              classes={{ root: this.props.classes.root }}
            >
              <Phone />
            </IconButton>
       
          <LogBox text={this.props.log} />
        </div>
      </div>
    )
  }
}

export default connect(
  state => ({
    modalOpen: state.phone.modalOpen,
    onPhone: state.phone.onPhone,
    muted: state.phone.muted,
    startTime: state.phone.startTime,
    log: state.phone.log,
    phoneTo:
      state.phone.to && state.phone.to.current && state.phone.to.current.value,
    token: state.voice.token,
    to:
      state.inbox.to && state.inbox.to.current && state.inbox.to.current.value,
    selectedFromNumber: state.inbox.fromNumberSelected,
    account_id:
      state.AccountSettings &&
      state.AccountSettings.settings &&
      state.AccountSettings.settings.id,
    contact_id:
      (state.inbox.contactSelected && state.inbox.contactSelected.id) ||
      state.inbox.conversationSelected,
    contact:
      (state.inbox.contactSelected || state.inbox.conversationSelected) &&
      state.contacts.contactsWithEmailsByID[
        state.inbox.contactSelected || state.inbox.conversationSelected
      ],
    vastUserName:
      state.auth.session &&
      state.auth.session.idToken &&
      state.auth.session.idToken.payload &&
      state.auth.session.idToken.payload['cognito:username'],
    messageMenuOpen: state.inbox.messageMenuOpen,
  }),
  dispatch =>
    bindActionCreators(
      {
        call,
        getClientToken,
        getClientTokenSchema,
        toggleModal,
        setPhoneState,
        toggleManagePhonesModal,
      },
      dispatch,
    ),
)(withStyles(styles)(PhoneCall))
